import { CommonModule, formatDate } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InteractionLogService } from 'src/app/services/interaction-log.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-duedatereport',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './duedatereport.component.html',
  styleUrl: './duedatereport.component.scss',
})
export class DuedatereportComponent implements OnInit {
  fromDate: string = '';
  toDate: string = '';
  rawSummary: any[] = [];
  pivotData: any[] = [];
  callNoteHeaders: string[] = [];

  selectedAgentDetails: any[] | null = null;
  selectedAgentName: string = '';
  dueTodayCount: number = 0;
  dueNext3DaysCount: number = 0;

  constructor(private interactionService: InteractionLogService) {}

  ngOnInit() {
    const today = new Date();
    const weekAgo = new Date(today);
    const weekAfter = new Date(today);
    weekAgo.setDate(today.getDate() - 7);
    weekAfter.setDate(today.getDate() + 7);

    this.fromDate = formatDate(weekAgo, 'yyyy-MM-dd', 'en');
    this.toDate = formatDate(weekAfter, 'yyyy-MM-dd', 'en');

    this.fetchSummary();
  }

  fetchSummary() {
    this.interactionService
      .getDueDateReportSummary(this.fromDate, this.toDate)
      .subscribe((data) => {
        this.rawSummary = data;
        this.transformToPivot(data);
      });
  }

  transformToPivot(data: any[]) {
    const pivot = new Map<number, any>();
    const notesSet = new Set<string>();

    data.forEach((row) => {
      const agentId = row.enteredBy;
      const note = row.callNotes || 'No Notes';

      notesSet.add(note);

      if (!pivot.has(agentId)) {
        pivot.set(agentId, {
          enteredBy: agentId,
          agentName: row.agentName,
          total: 0,
        });
      }

      const agentRow = pivot.get(agentId);
      agentRow[note] = (agentRow[note] || 0) + row.interactionCount;
      agentRow.total += row.interactionCount;
    });

    this.callNoteHeaders = Array.from(notesSet).sort();
    this.pivotData = Array.from(pivot.values());
  }

  openAgentDetails(agentId: number) {
    this.interactionService
      .getDueDateReportDetail(agentId, this.fromDate, this.toDate)
      .subscribe((data) => {
        this.selectedAgentDetails = data;
        const today = new Date();
        const next3Days = new Date();
        next3Days.setDate(today.getDate() + 3);

        let dueToday = 0;
        let dueNext3 = 0;

        data.forEach((d) => {
          const dueDate = new Date(d.nextDueDate);
          const isSameDay = dueDate.toDateString() === today.toDateString();
          const isInNext3 = dueDate > today && dueDate <= next3Days;

          if (isSameDay) dueToday++;
          if (isInNext3) dueNext3++;
        });

        this.dueTodayCount = dueToday;
        this.dueNext3DaysCount = dueNext3;
        const agent = this.pivotData.find((s) => s.enteredBy === agentId);
        this.selectedAgentName = agent ? agent.agentName : '';
      });
  }

  exportAsExcelFromBackend() {
    this.interactionService.downloadExcel(this.fromDate, this.toDate).subscribe(
      (blob) => {
        saveAs(
          blob,
          `interaction_summary_${this.fromDate}_to_${this.toDate}.xlsx`
        );
      },
      (error) => {
        console.error('Download failed', error);
      }
    );

    // const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    // const wb: XLSX.WorkBook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, 'Agent Summary');
    // XLSX.writeFile(wb, 'agent_summary.xlsx');
  }
}
